import React, {useState, useEffect} from 'react';
import ReactGA from 'react-ga';
import styled, {keyframes} from 'styled-components'
import QuestionData from "../Data/QustionData.json";
import StepGraph from "./StepGraph";
import magician from "../Img/the-magician@2x.png";
import magician_pressed from "../Img/the-magician-pressed@2x.png";
import the_magician from "../Img/the-magician@2x.png";
import the_magician_pressed from "../Img/the-magician-pressed@2x.png";
import the_hermit from "../Img/the-hermit@2x.png";
import the_hermit_pressed from "../Img/the-hermit-pressed@2x.png";
import hermit from "../Img/the-hermit@2x.png";
import hermit_pressed from "../Img/the-hermit-pressed@2x.png";
import the_empress from "../Img/the-empress@2x.png";
import the_empress_pressed from "../Img/the-empress-pressed@2x.png";
import the_high_priestess from "../Img/the-high-priestess@2x.png";
import the_high_priestess_pressed from "../Img/the-high-priestess-pressed@2x.png";
import high_priestess from "../Img/the-high-priestess@2x.png";
import high_priestess_pressed from "../Img/the-high-priestess-pressed@2x.png";
import the_lovers from "../Img/the-lovers@2x.png";
import the_lovers_pressed from "../Img/the-lovers-pressed@2x.png";
import hanged_man from "../Img/the-hanged-man@2x.png";
import hanged_man_pressed from "../Img/the-hanged-man-pressed@2x.png";
import the_hanged_man from "../Img/the-hanged-man@2x.png";
import the_hanged_man_pressed from "../Img/the-hanged-man-pressed@2x.png";
import the_emperor from "../Img/the-emperor@2x.png";
import the_emperor_pressed from "../Img/the-emperor-pressed@2x.png";
import emperor from "../Img/the-emperor@2x.png";
import emperor_pressed from "../Img/the-emperor-pressed@2x.png";
import the_justice from "../Img/justice@2x.png";
import the_justice_pressed from "../Img/justice-pressed@2x.png";
import justice from "../Img/justice@2x.png";
import justice_pressed from "../Img/justice-pressed@2x.png";
import the_sun from "../Img/the-sun@2x.png";
import the_sun_pressed from "../Img/the-sun-pressed@2x.png";
import the_tower from "../Img/the-tower@2x.png";
import the_tower_pressed from "../Img/the-tower-pressed@2x.png";
import the_star from "../Img/the-star@2x.png";
import the_star_pressed from "../Img/the-star-pressed@2x.png";
import star from "../Img/the-star@2x.png";
import star_pressed from "../Img/the-star-pressed@2x.png";
import the_devil from "../Img/the-devil@2x.png";
import the_devil_pressed from "../Img/the-devil-pressed@2x.png";
import the_strength from "../Img/the-strength@2x.png";
import the_strength_pressed from "../Img/the-strength-pressed@2x.png";
import strength from "../Img/the-strength@2x.png";
import strength_pressed from "../Img/the-strength-pressed@2x.png";
import the_moon from "../Img/the-moon@2x.png";
import the_moon_pressed from "../Img/the-moon-pressed@2x.png";
import moon from "../Img/the-moon@2x.png";
import moon_pressed from "../Img/the-moon-pressed@2x.png";
import moon_card from "../Img/the-moon@2x.png";
import moon_card_pressed from "../Img/the-moon-pressed@2x.png";
import the_hierophant from "../Img/the-hierophant@2x.png";
import the_hierophant_pressed from "../Img/the-hierophant-pressed@2x.png";
import the_death from "../Img/death@2x.png";
import the_death_pressed from "../Img/death-pressed@2x.png";
import the_fool from "../Img/the-fool@2x.png";
import the_fool_pressed from "../Img/the-fool-pressed@2x.png";
import HoverImage from "./HoverImage";


interface QuestionProps {
    getType(type: string ): void ;
}

interface InfoQuestionList {
    id:number;
    type: Array<string>;
    question: string;
    lastQuestion: string;
    answer: Array<Array<number | string>>;
    image: string;
}
// 인터페이스 생성
interface MbtiList {
    E: number,
    I: number,
    N: number,
    S: number,
    T: number,
    F: number,
    P: number,
    J: number,
}
// 객체 생성
let resultMap : MbtiList = {
    E: 0,
    I: 0,
    N: 0,
    S: 0,
    T: 0,
    F: 0,
    P: 0,
    J: 0,
}

const analyticsId = 'G-EK0Y8CQQZH';

declare const window: any;
declare const gtag: any;
declare const fbq: any;

const Question: React.FC<QuestionProps> = ({ getType }) => {
    const [questionList, setQuestionList] = useState<InfoQuestionList[]>([]);
    const [question, setQuestion] = useState<Partial<InfoQuestionList>>({});
    const [step, setStep] = useState<number>(1);
    const [type, setType] = useState<string>();
    const [calType, setCalType] = useState<Partial<MbtiList>>({});


    const fetchQuestions = (data: any):any => {
        setQuestionList(data.QuestionData);
        setQuestion(data.QuestionData[0]);

    }
    const clickChoice = (result: string): void => {
        gtag('event', 'Test_Tarotcard_Choice' , {
            event_category: 'Test_Tarotcard_Choice',
            event_label: 'Q'+step,
            value: step
        });
        gtag('event', 'Q'+step , {
            event_category: 'Q'+step,
            value: 'Q'+step
        });
        fbq('track', 'Test_Tarotcard_Choice' , {
            value: 'Q'+step
        });

        setStep(step + 1);
        setQuestion(questionList[step]);

            if (result === 'E') {
            question.type &&
            question.type.map((item: any) => {
                return(resultMap.E +=1);
            });
            setCalType(resultMap);
        }
        if (result === 'F') {
            question.type &&
            question.type.map((item: any) => {
                return(resultMap.F +=1);
            });
            setCalType(resultMap);
        }
        if (result === 'I') {
            question.type &&
            question.type.map((item: any) => {
                return(resultMap.I +=1);
            });
            setCalType(resultMap);
        }
        if (result === 'J') {
            question.type &&
            question.type.map((item: any) => {
                return(resultMap.J +=1);
            });
            setCalType(resultMap);
        }
        if (result === 'N') {
            question.type &&
            question.type.map((item: any) => {
                return(resultMap.N +=1);
            });
            setCalType(resultMap);
        }
        if (result === 'P') {
            question.type &&
            question.type.map((item: any) => {
                return(resultMap.P +=1);
            });
            setCalType(resultMap);
        }
        if (result === 'S') {
            question.type &&
            question.type.map((item: any) => {
                return(resultMap.S +=1);
            });
            setCalType(resultMap);
        }
        if (result === 'T') {
            question.type &&
            question.type.map((item: any) => {
                return(resultMap.T +=1);

            });
            setCalType(resultMap);
        }
        if (step === 12) {
            calculateType();
        }
    };
    const calculateType = (): void => {
        let answer = [];
        let index = -1;


        do {
            if ( resultMap.E > resultMap.I) {
                answer.push("E")
            } else {
                answer.push("I")
            }
            if ( resultMap.N > resultMap.S) {
                answer.push("N")
            } else {
                answer.push("S")
            }
            if ( resultMap.F > resultMap.T) {
                answer.push("F")
            } else {
                answer.push("T")
            }
            if ( resultMap.P > resultMap.J) {
                answer.push("P")
            } else {
                answer.push("J")
            }
        } while (index !== -1);
        if( answer.length > 1) {
            setType(answer.join(""))
            var answerType = answer.join("")
        } else {
            setType(answer[0])
        }
    };

    useEffect(() => {
        if (step === 1) {
            resultMap =
                {    E: 0,
                    I: 0,
                    N: 0,
                    S: 0,
                    T: 0,
                    F: 0,
                    P: 0,
                    J: 0
                }
            fetchQuestions(QuestionData);

        } else if (step === 13) {
            getType(String(type));
        }
    }, [step, getType, type])

    return (
        <QuestionWrap>
            {question &&
            <Content>
                <TitleWrap>
                    <SelectContents id="selectContents">
                    <QuestionNumber>
                        <span>Q{question.id}</span>
                    </QuestionNumber>
                    <QuestionTextWrap>
                        <Title>
                            <span className="txt-light">{question.question}</span>
                        </Title>
                        <Title>
                            <span>{question.lastQuestion}</span>
                        </Title>
                    </QuestionTextWrap>
                    <div>
                        <CardWrap>
                        {question.answer &&
                            question.answer.map((item: any) => {
                                // 1
                                if ( item.image === 'the_magician') {
                                return (
                                    <ButtonPosWrap onClick={() => clickChoice(item.id)}>
                                        <img src={the_magician} alt="the_magician" id="normal"/>
                                        <img src={the_magician_pressed} alt="the_magician_pressed" id="pressed"/>
                                        <SubTitle>
                                            <label>{item.subTitle}</label>
                                            <p>{item.hasTag}</p>
                                        </SubTitle>
                                    </ButtonPosWrap>
                                )}
                                if ( item.image === 'the_hermit') {
                                    return (
                                        <ButtonNagWrap onClick={() => clickChoice(item.id)}>
                                            <img src={the_hermit} alt="the_hermit" id="normal" />
                                            <img src={the_hermit_pressed} alt="the_hermit_pressed" id="pressed"/>
                                            <SubTitle style={{float:"right"}}>
                                                <label>{item.subTitle}</label>
                                                <p>{item.hasTag}</p>
                                            </SubTitle>
                                        </ButtonNagWrap>
                                    )}
                                // 2
                                if ( item.image === 'the_empress') {
                                    return (
                                        <ButtonPosWrap onClick={() => clickChoice(item.id)}>
                                            <img src={the_empress} alt="the_empress" id="normal" style={{float:"right"}}/>
                                            <img src={the_empress_pressed} alt="the_empress_pressed" id="pressed" style={{float:"right"}}/>
                                            <SubTitle style={{float:"right"}}>
                                                <label>{item.subTitle}</label>
                                                <p>{item.hasTag}</p>
                                            </SubTitle>
                                        </ButtonPosWrap>
                                    )}
                                if ( item.image === 'the_high_priestess') {
                                    return (
                                        <ButtonNagWrap onClick={() => clickChoice(item.id)}>
                                            <img src={the_high_priestess} alt="the_high_priestess" id="normal" style={{float:"left"}}/>
                                            <img src={the_high_priestess_pressed} alt="the_high_priestess_pressed" id="pressed" style={{float:"left"}}/>
                                            <SubTitle>
                                                <label>{item.subTitle}</label>
                                                <p>{item.hasTag}</p>
                                            </SubTitle>
                                        </ButtonNagWrap>
                                    )}
                                // 3
                                if ( item.image === 'the_lovers') {
                                    return (
                                        <ButtonPosWrap onClick={() => clickChoice(item.id)}>
                                            <img src={the_lovers} alt="the_lovers" id="normal"/>
                                            <img src={the_lovers_pressed} alt="the_lovers_pressed" id="pressed"/>
                                            <SubTitle>
                                                <label>{item.subTitle}</label>
                                                <p>{item.hasTag}</p>
                                            </SubTitle>
                                        </ButtonPosWrap>
                                    )}
                                if ( item.image === 'the_hanged_man') {
                                    return (
                                        <ButtonNagWrap onClick={() => clickChoice(item.id)}>
                                            <img src={the_hanged_man} alt="the_hanged_man" id="normal" />
                                            <img src={the_hanged_man_pressed} alt="the_hanged_man_pressed" id="pressed"/>
                                            <SubTitle style={{float: "right"}}>
                                                <label>{item.subTitle}</label>
                                                <p>{item.hasTag}</p>
                                            </SubTitle>
                                        </ButtonNagWrap>
                                    )}
                                // 4
                                if ( item.image === 'the_emperor') {
                                    return (
                                        <ButtonPosWrap onClick={() => clickChoice(item.id)}>
                                            <img src={the_emperor} alt="the_emperor" id="normal"/>
                                            <img src={the_emperor_pressed} alt="the_emperor_pressed" id="pressed"/>
                                            <SubTitle>
                                                <label>{item.subTitle}</label>
                                                <p>{item.hasTag}</p>
                                            </SubTitle>
                                        </ButtonPosWrap>
                                    )}
                                if ( item.image === 'the_justice') {
                                    return (
                                        <ButtonNagWrap onClick={() => clickChoice(item.id)}>
                                            <img src={the_justice} alt="the_justice" id="normal"/>
                                            <img src={the_justice_pressed} alt="the_justice_pressed" id="pressed"/>
                                            <SubTitle style={{float: "right"}}>
                                                <label>{item.subTitle}</label>
                                                <p>{item.hasTag}</p>
                                            </SubTitle>
                                        </ButtonNagWrap>
                                    )}
                                // 5
                                if ( item.image === 'the_sun') {
                                    return (
                                        <ButtonPosWrap onClick={() => clickChoice(item.id)}>
                                            <img src={the_sun} alt="the_sun" id="normal" style={{float: "right"}} />
                                            <img src={the_sun_pressed} alt="the_sun_pressed" id="pressed" style={{float: "right"}}/>
                                            <SubTitle style={{float: "right"}}>
                                                <label>{item.subTitle}</label>
                                                <p>{item.hasTag}</p>
                                            </SubTitle>
                                        </ButtonPosWrap>
                                    )}
                                if ( item.image === 'the_tower') {
                                    return (
                                        <ButtonNagWrap onClick={() => clickChoice(item.id)}>
                                            <img src={the_tower} alt="the_tower" id="normal" style={{float: "left"}} />
                                            <img src={the_tower_pressed} alt="the_tower_pressed" id="pressed" style={{float: "left"}} />
                                            <SubTitle>
                                                <label>{item.subTitle}</label>
                                                <p>{item.hasTag}</p>
                                            </SubTitle>
                                        </ButtonNagWrap>
                                    )}
                                // 6
                                if ( item.image === 'the_star') {
                                    return (
                                        <ButtonPosWrap onClick={() => clickChoice(item.id)}>
                                            <img src={the_star} alt="the_star" id="normal" />
                                            <img src={the_star_pressed} alt="the_star_pressed" id="pressed"/>
                                            <SubTitle>
                                                <label>{item.subTitle}</label>
                                                <p>{item.hasTag}</p>
                                            </SubTitle>
                                        </ButtonPosWrap>
                                    )}
                                if ( item.image === 'the_devil') {
                                    return (
                                        <ButtonNagWrap onClick={() => clickChoice(item.id)}>
                                            <img src={the_devil} alt="the_devil" id="normal" />
                                            <img src={the_devil_pressed} alt="the_devil_pressed" id="pressed" />
                                            <SubTitle style={{float: "right"}}>
                                                <label>{item.subTitle}</label>
                                                <p>{item.hasTag}</p>
                                            </SubTitle>
                                        </ButtonNagWrap>
                                    )}
                                // 7
                                if ( item.image === 'the_strength') {
                                    return (
                                        <ButtonPosWrap onClick={() => clickChoice(item.id)}>
                                            <img src={the_strength} alt="the_strength" id="normal" />
                                            <img src={the_strength_pressed} alt="the_strength_pressed" id="pressed" />
                                            <SubTitle>
                                                <label>{item.subTitle}</label>
                                                <p>{item.hasTag}</p>
                                            </SubTitle>
                                        </ButtonPosWrap>
                                    )}
                                if ( item.image === 'the_moon') {
                                    return (
                                        <ButtonNagWrap onClick={() => clickChoice(item.id)}>
                                            <img src={the_moon} alt="the_moon" id="normal" />
                                            <img src={the_moon_pressed} alt="the_moon_pressed" id="pressed" />
                                            <SubTitle style={{float: "right"}}>
                                                <label>{item.subTitle}</label>
                                                <p>{item.hasTag}</p>
                                            </SubTitle>
                                        </ButtonNagWrap>
                                    )}
                                // 8
                                if ( item.image === 'emperor') {
                                    return (
                                        <ButtonPosWrap onClick={() => clickChoice(item.id)}>
                                            <img src={emperor} alt="justice" id="normal" style={{float: "right"}}/>
                                            <img src={emperor_pressed} alt="justice_pressed" id="pressed" style={{float: "right"}}/>
                                            <SubTitle style={{float: "right"}}>
                                                <label>{item.subTitle}</label>
                                                <p>{item.hasTag}</p>
                                            </SubTitle>
                                        </ButtonPosWrap>
                                    )}
                                if ( item.image === 'moon') {
                                    return (
                                        <ButtonNagWrap onClick={() => clickChoice(item.id)}>
                                            <img src={moon} alt="the_hierophant" id="normal" style={{float: "left"}}/>
                                            <img src={moon_pressed} alt="the_hierophant_pressed" id="pressed" style={{float: "left"}}/>
                                            <SubTitle>
                                                <label>{item.subTitle}</label>
                                                <p>{item.hasTag}</p>
                                            </SubTitle>
                                        </ButtonNagWrap>
                                    )}
                                // 9
                                if ( item.image === 'magician') {
                                    return (
                                        <ButtonPosWrap onClick={() => clickChoice(item.id)}>
                                            <img src={magician} alt="magician" id="normal" style={{float: "right"}}/>
                                            <img src={magician_pressed} alt="magician_pressed" id="pressed" style={{float: "right"}}/>
                                            <SubTitle style={{float: "right"}}>
                                                <label>{item.subTitle}</label>
                                                <p>{item.hasTag}</p>
                                            </SubTitle>
                                        </ButtonPosWrap>
                                    )}
                                if ( item.image === 'hanged_man') {
                                    return (
                                        <ButtonNagWrap onClick={() => clickChoice(item.id)}>
                                            <img src={hanged_man} alt="hanged_man" id="normal" style={{float: "left"}}/>
                                            <img src={hanged_man_pressed} alt="hanged_man_pressed" id="pressed" style={{float: "left"}} />
                                            <SubTitle>
                                                <label>{item.subTitle}</label>
                                                <p>{item.hasTag}</p>
                                            </SubTitle>
                                        </ButtonNagWrap>
                                    )}
                                // 10
                                if ( item.image === 'star') {
                                    return (
                                        <ButtonPosWrap onClick={() => clickChoice(item.id)}>
                                            <img src={star} alt="star" id="normal" style={{float: "right"}}/>
                                            <img src={star_pressed} alt="star_pressed" id="pressed" style={{float: "right"}}/>
                                            <SubTitle style={{float: "right"}}>
                                                <label>{item.subTitle}</label>
                                                <p>{item.hasTag}</p>
                                            </SubTitle>
                                        </ButtonPosWrap>
                                    )}
                                if ( item.image === 'high_priestess') {
                                    return (
                                        <ButtonNagWrap onClick={() => clickChoice(item.id)}>
                                            <img src={high_priestess} alt="high_priestess" id="normal" style={{float: "left"}}/>
                                            <img src={high_priestess_pressed} alt="high_priestess_pressed" id="pressed" style={{float: "left"}}/>
                                            <SubTitle>
                                                <label>{item.subTitle}</label>
                                                <p>{item.hasTag}</p>
                                            </SubTitle>
                                        </ButtonNagWrap>
                                    )}
                                // 11
                                if ( item.image === 'moon_card') {
                                    return (
                                        <ButtonPosWrap onClick={() => clickChoice(item.id)} >
                                            <img src={moon_card} alt="hermit" id="normal" style={{float: "right"}}/>
                                            <img src={moon_card_pressed} alt="hermit_pressed" id="pressed" style={{float: "right"}}/>
                                            <SubTitle style={{float: "right"}}>
                                                <label>{item.subTitle}</label>
                                                <p>{item.hasTag}</p>
                                            </SubTitle>
                                        </ButtonPosWrap>
                                    )}
                                if ( item.image === 'strength') {
                                    return (
                                        <ButtonNagWrap onClick={() => clickChoice(item.id)}>
                                            <img src={strength} alt="the_death" id="normal" style={{float: "left"}}/>
                                            <img src={strength_pressed} alt="the_death_pressed" id="pressed" style={{float: "left"}}/>
                                            <SubTitle>
                                                <label>{item.subTitle}</label>
                                                <p>{item.hasTag}</p>
                                            </SubTitle>
                                        </ButtonNagWrap>
                                    )}
                                // 12
                                if ( item.image === 'the_fool') {
                                    return (
                                        <ButtonPosWrap onClick={() => clickChoice(item.id)}>
                                            <img src={the_fool} alt="the_fool" id="normal" />
                                            <img src={the_fool_pressed} alt="the_fool_pressed" id="pressed" />
                                            <SubTitle>
                                                <label>{item.subTitle}</label>
                                                <p>{item.hasTag}</p>
                                            </SubTitle>
                                        </ButtonPosWrap>
                                    )}
                                if ( item.image === 'the_justice') {
                                    return (
                                        <ButtonNagWrap onClick={() => clickChoice(item.id)}>
                                            <img src={the_justice} alt="the_justice" id="normal" />
                                            <img src={the_justice_pressed} alt="the_justice_pressed" id="pressed" />
                                            <SubTitle>
                                                <label>{item.subTitle}</label>
                                                <p>{item.hasTag}</p>
                                            </SubTitle>
                                        </ButtonNagWrap>
                                    )}
                            })
                            }
                        </CardWrap>
                    </div>
                    </SelectContents>
                    <Step>
                      <StepGraph step={step}/>
                        <span> {step} / 12</span>
                    </Step>
                </TitleWrap>
            </Content>
            }
        </QuestionWrap>
    );
};

export default Question;
const fadein = keyframes`
       from {
            opacity: 0;
        }
 
        to {
            opacity: 1;
        }
    }
`
const fadeOut = keyframes`
       from {
           opacity: 1;
            transform: none;  
        }
 
        to {
           
            opacity: 0;
            transform: translateY(50px);
        }
    }
`

const QuestionWrap = styled.div `
   position: absolute;
   width: 100%;
   overflow: hidden;
          @media only screen and (min-width: 768px) {
                top: 0;
                left: 0;
  }
`



const Content = styled.div`
    height: 100%;
    margin: 0 auto;
    display: inline-block;
    padding: 0 30px;
    animation: ${fadein} 1s;
    
`
const SelectContents = styled.div`
    width: 100%;
    height: 100%;
    float: left;
`

const TitleWrap = styled.div`
    margin: 60px 0 0px 0;
    float: left;
    width: 315px;
    height: 100%;
    @media (max-width: 767px) {
        margin: 30px 0 0 0;
    }
`

const Title = styled.div`
    width: 100%;
    font-size: 20px;
    font-weight: 500;
    line-height: 32px;
    color: #dddddd;
    float: left;
    text-align: left;
    font-family:'GmarketSansTTFLight', sans-serif;
    .txt-light {
        font-weight: 500;
        font-family:'GmarketSansTTF', sans-serif;
        white-space: pre-line;
        }
`

const QuestionNumber = styled.div`
    width: 100%;
    height: 26px;
    font-family: 'GmarketSansTTF', sans-serif;
    margin-bottom: 20px;
    font-size: 26px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal; 
    color: #ffcf24;
    float: left;
    text-align: left;
    .txt-light {
        font-weight: 500;
        }
`
const QuestionTextWrap = styled.div`
    width: 100%;
    height: 96px;
    float: left;
    
`
const CardWrap = styled.div`
`
const ButtonPosWrap = styled.div`
    float: left;
    width: 50%;
    height: 100%;
    margin: 40px 0 45px 0;
    text-align: center;
    
    img {
      cursor: pointer;
      width: 145px;;
      height: 240px;
      object-fit: contain;
      float: left;
      -webkit-touch-callout:none
      
    }
    #normal {
        display:block;
    }
    #pressed {
        display:none;
    }
    &:hover #normal,
       &:active #normal{
        display:none;
       
    }
    &:hover #pressed,
       &:active #pressed{
        display:block;
         
    }
    @media (max-width: 1024px) {
    float: left;
    width: 50%;
    margin: 30px 0 25px 0;
      #normal {
      animation: ${fadein} 1s;
      }
      &:hover #normal{
        display:block;
   }
      &:hover #pressed{
        display:none;
   }
     &:active #normal{
        display:none;
   }
     &:active #pressed{
        display:block;
        }
   }
`

const ButtonNagWrap = styled.div`
    float: left;
    width: 50%;
    margin: 40px 0 45px 0;
    img {
      cursor: pointer;
      width: 145px;;
      height: 240px;
      object-fit: contain;
      float: right;
      -webkit-touch-callout:none;
    }
    #normal {
        display:block;
        
    }
    #pressed {
        display:none;
    }
    &:hover #normal,
     &:active #normal {
        display:none;
    }
    &:hover #pressed,
     &:active #pressed {
        display:block;
    }
      @media (max-width: 1024px) {
        float: left;
        width: 50%;
      margin: 30px 0 25px 0;
      #normal {
      animation: ${fadein} 1s;
      }
       &:hover #normal{
        display:block;
   }
      &:hover #pressed{
        display:none;
   }
     &:active #normal{
        display:none;
   }
     &:active #pressed{
        display:block;
        }
   }
`

const Step = styled.div`
    width: 100%;
    text-align: right;
    font-size: 12px;
    font-weight: normal;
    color: #7f7f7f;
    line-height: normal;
    span {
    font-family: NanumGothic;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    margin-bottom: 0;
    float:right;
    }
`
const SubTitle = styled.div`
    width: 145px;
    height: 36px;
    float: left;
    text-align: center;
    label {
         font-family: NanumGothic-Bold;
         font-size: 12px;
         height: 12px;
         line-height: 18px;
         font-stretch: normal;
         font-weight: bold;
         font-style: normal;
         letter-spacing: normal;
         text-align: center;
         color: #dddddd;
    }
    p {
      font-family: NanumGothic;
      font-size: 12px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 18px;
      letter-spacing: normal;
      text-align: center;
      color: #dddddd;
      margin: 0 auto;
      height: 12px;
      
    }
`



